import { render, staticRenderFns } from "./HelpMenuContent.vue?vue&type=template&id=23a5f1ec"
import script from "./HelpMenuContent.vue?vue&type=script&lang=js"
export * from "./HelpMenuContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports